'use strict'

let accordionSectionIsOpen = false

const MarkDownHelper = {
  renderItem (item, specialMode) {
    let html = this.getHtml(item, specialMode)
    html = this.createBold(html)
    html = this.createLinks(html)
    return html
  },
  getHtml (item, specialMode) {
    switch (item.type) {
      case 'heading':
        if (item.depth === 1) return `<h1>${item.text}</h1>`
        if (item.depth === 2) {
          if (specialMode === 'accordion') return this.newAccordionSection(item)
          return `<h2>${item.text}</h2>`
        }
        if (item.depth === 3) return `<h3>${item.text}</h3>`
        if (item.depth === 4) return `<h4>${item.text}</h4>`
        if (item.depth === 5) return `<h5>${item.text}</h5>`
        return `<h6>${item.text}</h6>`
      case 'paragraph':
        return `<p>${item.text}</p>`
      case 'list_start':
        return '<ul>'
      case 'list_end':
        return '</ul>'
      case 'list_item_start':
      case 'loose_item_start':
        return '<li>'
      case 'list_item_end':
      case 'loose_item_end':
        return '</li>'
      case 'text':
        return item.text
      case 'space':
        return ' '
      case 'table':
        return this.renderTable(item)
    }
  },
  renderTable (item) {
    if (!item.cells) return ''
    let tableHtml = '<div class="table-container"><table class="table table-striped table-condensed"><tbody>'
    item.cells.map((cell) => {
      tableHtml += '<tr>'
      cell.map((item) => {
        tableHtml += `<td>${item}</td>`
      })
      tableHtml += '</tr>'
    })
    tableHtml += '</tbody></table></div>'
    return tableHtml
  },
  newAccordionSection (item) {
    let html = ''
    if (accordionSectionIsOpen) {
      html += '</div></div>'
      accordionSectionIsOpen = false
    }
    html += `<div class="accordion closed"><h2 onclick="this.parentNode.classList.toggle('closed');">${item.text}</h2><div class="accordion-content">`
    accordionSectionIsOpen = true
    return html
  },
  createBold (html) {
    if (!html) return
    return html.replace(/\*{2}(.+?)\*{2}/g, '<strong>$1</strong>')
  },
  createLinks (html) {
    if (!html) return
    return html.replace(/\[(.*?)\]\((.+?)\)/g, '<a href="$2">$1</a>')
  }
}

module.exports = MarkDownHelper



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/markdown/MarkDownHelper.js